import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  const { t } = useTranslation();
  const latest = articles.slice(0, 3);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              {t('articles.title')}
            </h2>
            <p className="text-sm text-foreground-500">
              {t('articles.subtitle')}
            </p>
          </div>
          <Link
            to="/articles"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer transition-colors flex items-center gap-1"
          >
            {t('articles.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              summary={article.summary}
              author={article.author}
              publishDate={article.publishDate}
              readCount={article.readCount}
              image={article.image}
              category={
                article.category === 'beauty'
                  ? '美容'
                  : article.category === 'hair'
                  ? '美发'
                  : article.category === 'nail'
                  ? '美甲'
                  : '美体'
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
}